export default "__VITE_ASSET__db610189__"